import { HashLink } from "react-router-hash-link";

const section = () => {
  return (
    <div className="pt-14 max-w-[1146px] mx-auto md:px-0 px-4 pb-[45px]">
      <h1 className="text-center text-primary-color font-semibold text-4xl mt-6 md:mt-10 pb-12">
        Experience <span>🛠</span>
      </h1>
      <div className="flex flex-col-reverse md:flex-row justify-center items-center gap-12 mt-14">
        <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
          <div className={`space-y-4 text-center`}>
            <div className="text-left space-y-2">
              <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
                WOLT
              </h1>
              <h1 className="text-primary-color font-semibold text-md md:text-lg ">
                JUNE 2026 - TO NOW
              </h1>
            </div>
            <div className="text-left">
              <p className="text-sm font-normal leading-loose opacity-60">
                Part of the Courier Fleet team, working on DeliveryOS, a
                platform for managing fleet companies and couriers.
              </p>
              <br />
              <p className="text-sm font-normal leading-loose opacity-60">
                - Building and improving scalable features using TypeScript.
              </p>
              <br />
              <HashLink
                smooth
                to="/experiences#exp-wolt"
                className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
              >
                Read More
              </HashLink>
            </div>
          </div>
        </div>
        <img
          style={{ position: "relative", zIndex: 1 }}
          src="/images/5.svg"
          alt="banner"
          className="block max-w-[80%] md:max-w-[400px] bg-white m-0 p-0"
        />
      </div>
      <div className="hidden md:flex flex-row justify-center items-center">
        <div
          style={{ position: "relative", zIndex: -1 }}
          className={`border-t-[3px] border-dashed border-[#000] w-1/2 ${"-rotate-45"}`}
        ></div>
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center gap-12 mt-14">
        <img
          style={{ position: "relative", zIndex: 1 }}
          src="/images/1.svg"
          alt="banner"
          className="block max-w-[80%] md:max-w-[400px] bg-white m-0 p-0"
        />
        <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
          <div className={`md:pl-14 space-y-4 text-center`}>
            <div className=" text-left space-y-2">
              <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
                MINDERA
              </h1>
              <h1 className="text-primary-color font-semibold text-md md:text-lg ">
                NOVEMBER 2022 - JUNE 2026
              </h1>
            </div>
            <div className="text-left">
              <p className="text-sm font-normal leading-loose opacity-60">
                Mindera partners with global clients to build large-scale
                digital products across sectors like telecommunications, retail
                and IoT.
              </p>
              <br />
              <p className="text-sm font-normal leading-loose opacity-60">
                Client: Vodafone
              </p>
              <p className="text-sm font-normal leading-loose opacity-60">
                - I led the frontend team modernizing Vodafone Subscription+, a
                customer rewards platform offering discounted subscriptions from
                entertainment partners like Netflix, Spotify, and HBO.
              </p>
              <br />
              <HashLink
                smooth
                to="/experiences#exp-mindera"
                className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
              >
                Read More
              </HashLink>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md:flex flex-row justify-center items-center">
        <div
          style={{ position: "relative", zIndex: -1 }}
          className={`border-t-[3px] border-dashed border-[#000] w-1/2 ${"rotate-45"}`}
        ></div>
      </div>
      <div className="flex flex-col-reverse md:flex-row justify-center items-center gap-12 mt-14">
        <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
          <div className={`space-y-4 text-center`}>
            <div className="text-left space-y-2">
              <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
                RIVER-DONE DIGITAL
              </h1>
              <h1 className="text-primary-color font-semibold text-md md:text-lg ">
                MAY 2022 - NOVEMBER 2022
              </h1>
            </div>
            <div className="text-left">
              <p className="text-sm font-normal leading-loose opacity-60">
                RiverDone Digital delivers custom digital products for clients
                in Web3, fintech, and SaaS industries.
              </p>
              <br />
              <p className="text-sm font-normal leading-loose opacity-60">
                Finimize Referral Feature:
              </p>
              <br />
              <p className="text-sm font-normal leading-loose opacity-60">
                - I took technical ownership of the frontend implementation of a
                new referral feature for Finimize, enhancing user acquisition
                and engagement.
              </p>
              <br />
              <HashLink
                smooth
                to="/experiences#exp-riverdone"
                className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
              >
                Read More
              </HashLink>
            </div>
          </div>
        </div>
        <img
          style={{ position: "relative", zIndex: 1 }}
          src="/images/3.svg"
          alt="banner"
          className="block max-w-[80%] md:max-w-[400px] bg-white m-0 p-0"
        />
      </div>
      <div className="hidden md:flex flex-row justify-center items-center">
        <div
          style={{ position: "relative", zIndex: -1 }}
          className={`border-t-[3px] border-dashed border-[#000] w-1/2 ${"-rotate-45"}`}
        ></div>
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center gap-12 mt-14">
        <img
          style={{ position: "relative", zIndex: 1 }}
          src="/images/6.svg"
          alt="banner"
          className="block max-w-[80%] md:max-w-[400px] bg-white m-0 p-0"
        />
        <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
          <div className={`md:pl-14 space-y-4 text-center`}>
            <div className=" text-left space-y-2">
              <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
                NU TERRA LABS
              </h1>
              <h1 className="text-primary-color font-semibold text-md md:text-lg ">
                FEBRUARY 2022 - MAY 2022
              </h1>
            </div>
            <div className="text-left">
              <p className="text-sm font-normal leading-loose opacity-60">
                Nu Terra Labs provides digital marketing and technology
                solutions in the agriculture sector.
              </p>
              <br />
              <p className="text-sm font-normal leading-loose opacity-60">
                - I migrated the existing single-page React application to
                Next.js with server-side rendering, significantly improving SEO
                performance, load times and indexing.
              </p>
              <p className="text-sm font-normal leading-loose opacity-60">
                - Optimized overall site performance and accessibility, leading
                to better engagement and organic visibility.
              </p>
              <br />
              <HashLink
                smooth
                to="/experiences#exp-nuterralabs"
                className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
              >
                Read More
              </HashLink>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md:flex flex-row justify-center items-center">
        <div
          style={{ position: "relative", zIndex: -1 }}
          className={`border-t-[3px] border-dashed border-[#000] w-1/2 ${"rotate-45"}`}
        ></div>
      </div>
      <div className="flex flex-col-reverse md:flex-row justify-center items-center gap-12 mt-14">
        <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
          <div className={`space-y-4 text-center`}>
            <div className="text-left space-y-2">
              <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
                SMARTINIA
              </h1>
              <h1 className="text-primary-color font-semibold text-md md:text-lg ">
                FEBRUARY 2021 - FEBRUARY 2022
              </h1>
            </div>
            <div className="text-left">
              <p className="text-sm font-normal leading-loose opacity-60">
                Smartinia builds SaaS products in e-commerce, e-learning, and
                logistics.
              </p>
              <br />
              <p className="text-sm font-normal leading-loose opacity-60">
                E-Commerce Platform:
              </p>
              <p className="text-sm font-normal leading-loose opacity-60">
                - I developed product pages, basket, checkout, and payment
                features with seamless UX.
              </p>
              <p className="text-sm font-normal leading-loose opacity-60">
                - Improved page load times and UI responsiveness across
                devices.{" "}
              </p>
              <br />
              <HashLink
                smooth
                to="/experiences#exp-smartinia"
                className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
              >
                Read More
              </HashLink>
            </div>
          </div>
        </div>
        <img
          style={{ position: "relative", zIndex: 1 }}
          src="/images/4.svg"
          alt="banner"
          className="block max-w-[80%] md:max-w-[400px] bg-white m-0 p-0"
        />
      </div>
      <div className="hidden md:flex flex-row justify-center items-center">
        <div
          style={{ position: "relative", zIndex: -1 }}
          className={`border-t-[3px] border-dashed border-[#000] w-1/2 ${"-rotate-45"}`}
        ></div>
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center gap-12 mt-14">
        <img
          style={{ position: "relative", zIndex: 1 }}
          src="/images/5.svg"
          alt="banner"
          className="block max-w-[80%] md:max-w-[400px] bg-white m-0 p-0"
        />
        <div className="flex flex-row items-center justify-center space-x-2 max-w-[475px]">
          <div className={`md:pl-14 space-y-4 text-center`}>
            <div className="text-left space-y-2">
              <h1 className="text-[#000] font-semibold text-xl md:text-2xl ">
                FASTY DELIVERY
              </h1>
              <h1 className="text-primary-color font-semibold text-md md:text-lg ">
                AUGUST 2019 - AUGUST 2020
              </h1>
            </div>
            <div className="text-left">
              <p className="text-sm font-normal leading-loose opacity-60">
                Fasty is a food delivery platform connecting local restaurants
                with customers.
              </p>
              <br />
              <p className="text-sm font-normal leading-loose opacity-60">
                - I built an administrative web application to simplify and
                accelerate menu and restaurant data entry.
              </p>
              <p className="text-sm font-normal leading-loose opacity-60">
                - Automated data collection and transformation workflows using
                Node.js and Python scripts, reducing manual input time.
              </p>
              <br />
              <HashLink
                smooth
                to="/experiences#exp-fasty"
                className="cursor-pointer underline text-sm font-normal leading-loose opacity-60"
              >
                Read More
              </HashLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default section;
